<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-actions class="pb-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            class="text-xs-right"
                            color="success"
                            @click="submit"
                            >Submit</v-btn
                        >
                    </v-card-actions>
                    <v-layout column>
                        <v-card-actions class="pt-0">
                            <v-layout row>
                                <v-flex xs4 class="pt-0">
                                    <v-card-text class="pl-2"
                                        >Search By Name</v-card-text
                                    >
                                    <vue-select2
                                        style="font-size: 27px"
                                        class="mb-3 ml-2 select2-custom"
                                        :options="accounts"
                                        label="displayName"
                                        v-model="account"
                                        :filterable="false"
                                        @search="onSearchAccounts"
                                        @input="onSelected"
                                    ></vue-select2>
                                </v-flex>
                                <v-flex xs6 class="pt-0">
                                    <v-card-text class="pl-0"
                                        >Search By Phone Number</v-card-text
                                    >
                                    <v-layout row>
                                        <v-text-field
                                            solo
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            mask="###-###-####"
                                            @input="searchByPhone"
                                        ></v-text-field>
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        >
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="newAccountDialog = true"
                                            >New Account</v-btn
                                        >
                                        <v-btn
                                            v-if="account.nonUTA"
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="editAccount"
                                            >Edit Account</v-btn
                                        >
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <div v-if="account.accountID">
                            <v-flex xs12 class="pt-0">
                                <v-layout row>
                                    <v-layout column class="ml-4">
                                        <v-card-title
                                            primary-title
                                            class="pt-3 py-0"
                                        >
                                            <div>
                                                <v-layout
                                                    row
                                                    v-if="account.nonUTA"
                                                    align-center
                                                    class="pl-2 py-2"
                                                >
                                                    <h3 class="headline my-0">
                                                        Account ID:
                                                        {{ account.accountID }}
                                                    </h3>
                                                    <div
                                                        class="font-weight-medium ml-2 text-info"
                                                    >
                                                        Non UTA
                                                    </div>
                                                </v-layout>
                                                <h3
                                                    class="headline my-0"
                                                    v-if="!account.nonUTA"
                                                >
                                                    Account ID:
                                                    {{ account.accountID }}
                                                </h3>
                                            </div>
                                        </v-card-title>
                                        <v-card-text class="mb-2 py-0">
                                            <h4
                                                class="card-title font-weight-medium"
                                            >
                                                {{ account.name }}
                                            </h4>
                                            <p>
                                                {{ account.hname }}
                                            </p>
                                            <p>
                                                {{ account.address1 }}
                                            </p>
                                            <br />
                                            <div class="ml-2 mt-2">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home:
                                                    </div>
                                                    <div>
                                                        {{ account.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell:
                                                    </div>
                                                    <div>
                                                        {{ account.cellPhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-card-text>
                                    </v-layout>
                                    <v-layout row wrap align-end fluid>
                                        <v-card-actions
                                            class="mr-5"
                                            style="width: 100%;"
                                        >
                                            <!-- <v-btn
                                                class="ml-3 mb-3"
                                                color="info"
                                                @click="newStudentDialog = true"
                                            >
                                                New Student
                                            </v-btn> -->
                                        </v-card-actions>
                                    </v-layout>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <student-list
                    v-if="students.length"
                    :students="students"
                    :classes="classes"
                    :account="account"
                    :gradesSetup="gradesSetup"
                    :dates="dates"
                    :charges="charges"
                    source="YKC"
                    ref="studentsList"
                >
                </student-list>
            </v-flex>
        </v-layout>

        <v-dialog v-model="confirmDialog" max-width="500">
            <v-card>
                <v-card-title class="headline"
                    >Confirm Registration</v-card-title
                >

                <div class="font-weight-medium ml-3">
                    The following students will be registred for camp
                </div>
                <v-list two-line>
                    <template
                        v-for="(student, index) in students.filter(
                            (s) => s.duration != 'NONE'
                        )"
                    >
                        <v-list-tile avatar ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    student.engName
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title
                                    >Duration: {{ getDurationDisplay(student) }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                            v-if="
                                index + 1 <
                                    students.filter((s) => s.duration != 'NONE')
                                        .length
                            "
                        ></v-divider>
                    </template>
                </v-list>

                <v-card-actions class="text-xs-right pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        class="text-xs-right"
                        @click="confirmDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :disabled="processing"
                        class="text-xs-right"
                        color="success"
                        :loading="processing"
                        @click="confirm(false)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="newAccountDialog" max-width="800">
            <new-account
                ref="newAccount"
                :closeNewAccountModal="closeNewAccountModal"
                :onCreated="onNewAccountCreated"
            ></new-account>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
    </v-container>
</template>
<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../../utils/helpers.js";
import odata from "odata-client";
import ky from "../../utils/ky.js";
import studentsList from "./StudentList.vue";
import payment from "../LapidusDayCamp/Payment.vue";
import newAccount from "../LapidusDayCamp/newAccount.vue";
import newStudent from "../LapidusDayCamp/newStudent.vue";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
        "student-list": studentsList,
        "new-account": newAccount,
        "new-student": newStudent,
    },
    data: () => ({
        phoneSearch: "",
        accounts: [],
        countries: [],

        account: {},
        country: "",
        bungalow: "",
        customCountry: "",
        note: "",

        uploading: false,
        files: [],
        lunchDocument: false,
        lunchProgramIneligible: false,
        lunchDocumentUrl: "",

        students: [],
        cardHistory: [],
        rates: [],
        dates: [],

        gradesSetup: [],
        classes: [],

        charges: [],

        confirmDialog: false,
        processing: false,

        countryRules: [(value) => !!value || "Required."],

        customCountryRules: [(value) => !!value || "Required."],

        searchDialogTitle: "Accounts",
        searchDialog: false,

        newAccountDialog: false,
        newStudentDialog: false,

        regID: "",

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        await this.loadGradesSetup();
        await this.loadRegID();
        await this.loadCharges();

        this.loadClasses();
        this.loadCountries();
    },
    mounted() {
        window.addEventListener("keyup", this.onKeyPressed);
    },
    methods: {
        onKeyPressed(e) {},
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get("api/yk/getGradesSetup");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID
            );

            this.classes = classes.filter((c) => {
                return c.regID.trim() == this.regID && c.classType != "Bunk";
            });
        },
        async loadRates() {
            const rates = await this.$http.get(
                "api/lapidusDayCamp/getDayCampSetup"
            );

            this.rates = rates.filter((r) => r.udcregid == this.regID);
        },
        async loadCardHistory() {
            this.cardHistory = await this.$http.get(
                "api/lapidusDayCamp/getCardHistory?accountID=" +
                    this.account.accountID
            );
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName =
                    account.lastName + " " + account.firstName;

                return account;
            });

            loading(false);
        },
        async loadCharges() {
            const charges = await this.$http.get("api/yk/getcharges");

            this.charges = charges;
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewAccountCreated(account) {
            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewStudentCreated(student) {
            this.newStudentDialog = false;

            this.students.push(this.mapStudent(student));
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/lapidusDayCamp/getAccountByPhoneNumber?phoneNumber=${value}`
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                return;
            }

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];

            this.onAccountSelected();
        },
        async onAccountSelected() {
            this.students = [];

            const exist = await this.validateExistence();

            if (exist) return;

            this.loadStudets();
            //this.loadCardHistory();
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/lapidusDayCamp/uploadLunchDocument",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.lunchDocumentUrl = response;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        bungalowRequired() {
            return this.country == "Satmar - Lapidus" && !this.bungalow;
        },
        async validateExistence() {
            const exist = await this.$http.get(
                "api/yk/getYKCAccount?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID
            );

            if (!exist) return false;

            if (exist) {
                this.$notify({
                    text: "Account Already Exist",
                    group: "notification",
                    type: "error",
                });

                return true;
            }
        },
        async loadStudets() {
            const students = await ky.get(
                this.$Progress,
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`
            );

            this.students = students
                .filter(this.hasYKCamp)
                .map(this.mapStudent);
        },
        hasYKCamp(student) {
            if (!this.gradesSetup.find((g) => g.grade == student.class)) return;

            return this.gradesSetup.find((g) => g.grade == student.class)
                .isYKCAvail;
        },
        mapStudent(student) {
            student.duration = "FULL";
            student.selected = false;
            student.chosenClass = "";
            student.editingAmount = false;
            student.lunchDoc = false;

            student.charges = JSON.parse(
                JSON.stringify(
                    this.charges.map((charge) => {
                        charge.paymentAmount = charge.amount;

                        return charge;
                    })
                )
            );

            student.explicitWeeks = {
                week1: true,
                week2: true,
                week3: true,
                week4: true,
                week5: true,
                week6: true,
                week7: true,
                week8: true,
                week9: true,
            };

            student.price = () => this.getRate(student);
            student.paymentAmount = student.price();

            const charges = sum(student.charges.map((c) => +c.paymentAmount));
            student.total = +student.paymentAmount + charges;

            return student;
        },
        getRate(student) {
            return 3000;
        },
        clearSelection() {
            this.phoneSearch = "";
            this.students = [];
        },
        getPaymentAmount() {
            return sum(
                this.students.map((s) => +s.paymentAmount || +s.price())
            );
        },
        submit() {
            if (
                !this.account ||
                this.students.every((s) => s.duration == "NONE")
            ) {
                this.$notify({
                    text: this.getErrorMessage(),
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const validations = [this.$refs.studentsList.validate(true)];

            if (!validations.every(Boolean)) return;

            this.openConfirmDialog();
        },
        getErrorMessage() {
            if (!this.account) return "No Account Selected";

            return this.students.length
                ? "Please Chose Duration"
                : "No Students";
        },
        openConfirmDialog() {
            this.confirmDialog = true;
        },
        getDurationDisplay(student) {
            if (student.duration != "CUSTOM") return student.duration;

            const weekCount = Object.keys(student.explicitWeeks)
                .map((key) => student.explicitWeeks[key])
                .filter(Boolean).length;

            return weekCount + " Weeks";
        },
        getApplicationData() {
            const enrollments = this.students
                .filter((s) => s.duration != "NONE")
                .map((student) => ({
                    familyID: this.account.accountID,
                    studentID: student.studentID,
                    regID: this.regID,
                    regType: student.duration,
                    class: student.class,
                    //classId: student.chosenClass.classID,
                    chargeCat: "YKC",
                    chargeCode: this.regID,
                    amount: +(student.paymentAmount || student.price()),
                    week1: this.hasWeek(student, 1),
                    week2: this.hasWeek(student, 2),
                    week3: this.hasWeek(student, 3),
                    week4: this.hasWeek(student, 4),
                    week5: this.hasWeek(student, 5),
                    week6: this.hasWeek(student, 6),
                    week7: this.hasWeek(student, 7),
                    week8: this.hasWeek(student, 8),
                    week9: this.hasWeek(student, 9),
                    //price: +student.price(),
                    price: student.price(),
                }));

            const charges = this.students
                .filter((s) => s.duration != "NONE")
                .map((student) => {
                    return student.charges.map((charge) => {
                        return {
                            studentID: student.studentID,
                            chargeName: charge.name,
                            amount: charge.paymentAmount
                                ? charge.paymentAmount
                                : 0,
                        };
                    });
                });

            const data = {
                user: this.$store.state.authentication.user,
                enrollments: enrollments,
                charges: charges.flat(),
            };

            return data;
        },

        hasWeek(student, week) {
            switch (student.duration) {
                case "FULL":
                    return true;
                case "CUSTOM":
                    const field = "week" + week;

                    return !!student.explicitWeeks[field];
                case "HALF 1":
                    return week >= 1 && week <= 5;
                case "HALF 2":
                    return week >= 5 && week <= 9;
            }
        },
        async confirm(goToNext = false) {
            const applicationData = this.getApplicationData();

            this.processing = true;

            try {
                await ky.post(this.$Progress, "api/yk/apply", {
                    queryParams: {
                        accountID: this.account.accountID,
                    },
                    data: applicationData,
                });
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            if (goToNext) {
                this.account = {};
                this.students = [];

                this.phoneSearch = "";
                this.country = "";
                this.customCountry = "";
                this.note = "";

                this.confirmDialog = false;

                this.$notify({
                    text: "Registration Successful",
                    group: "notification",
                    type: "success",
                });

                return;
            }

            this.$notify({
                text: "Registration Successful",
                group: "notification",
                type: "success",
            });

            this.confirmDialog = false;

            this.$router.push({
                name: "YKCAccountView",
                params: { id: this.account.accountID, reg_id: this.regID },
            });
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.v-btn__content {
    color: unset;
}
.bungalow-required {
    border-bottom: 2px red solid;
}
</style>
